import React from 'react';

const HowItWorksPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container-width section-padding py-20">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">How It Works</h1>
          <p className="text-xl text-gray-600">Coming soon - Interactive chapter structure and process guide</p>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksPage;
